
(function () {
  function rootPath() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/').replace(/\/?$/, '/');
  }
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-fx-buy-now]');
    if (!button || button.disabled || button.dataset.fxBusy === 'true') return;
    event.preventDefault();
    const form = button.closest('form');
    const variantId = button.dataset.variantId || (form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
    const quantityField = form && form.querySelector('[name="quantity"]');
    const quantity = Math.max(1, parseInt(quantityField ? quantityField.value : '1', 10) || 1);
    if (!variantId) {
      window.alert('Please choose a product variant first.');
      return;
    }
    const original = button.innerHTML;
    button.dataset.fxBusy = 'true';
    button.disabled = true;
    button.textContent = 'Preparing secure checkout…';
    try {
      const response = await fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'This item cannot be added to the cart right now.');
      }
      window.location.assign(rootPath() + 'checkout');
    } catch (err) {
      button.disabled = false;
      button.dataset.fxBusy = 'false';
      button.innerHTML = original;
      window.alert(err.message || 'Unable to proceed to checkout. Please try again.');
    }
  });
})();
